import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ErrorHandlerService } from '../commons/error-handler.service';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {
  private _baseUrl = `${environment.apiUrl}/empresa`;
  private _errorHandler = inject(ErrorHandlerService);
  private _httpClient = inject(HttpClient);

  obtenerDatos() {
    const url = `${this._baseUrl}/obtener-datos`;

    return this._httpClient.get(url).pipe(
      map((response: any) => response.payload),
      catchError((error: any) => {
        this._errorHandler.received(error);
        throw new Error(error.error.message);
      })
    )
  }

  actualizarDatos(body: any) {
    const url = `${this._baseUrl}/actualizar`;

    return this._httpClient.put(url, body).pipe(
      map((response: any) => response.payload),
      catchError((error: any) => {
        this._errorHandler.received(error);
        throw new Error(error.error.message);
      })
    )
  }

  obtenerConfiguracionRondas() {
    const url = `${this._baseUrl}/configuracion-rondas`;
    return this._httpClient.get(url).pipe(
      map((response: any) => response.payload),
      catchError((error: any) => {
        this._errorHandler.received(error);
        throw new Error(error.error?.message || 'Error al obtener la configuración de rondas');
      })
    );
  }

  actualizarConfiguracionRondas(body: { rondas_libres_habilitadas: boolean; solicitar_motivo_finalizacion: boolean }) {
    const url = `${this._baseUrl}/configuracion-rondas`;
    return this._httpClient.put(url, body).pipe(
      map((response: any) => response.payload),
      catchError((error: any) => {
        this._errorHandler.received(error);
        throw new Error(error.error?.message || 'Error al actualizar la configuración de rondas');
      })
    );
  }

  obtenerHorariosNotificacion() {
    const url = `${this._baseUrl}/horarios-notificacion`;
    return this._httpClient.get(url).pipe(
      map((response: any) => response.payload),
      catchError((error: any) => {
        this._errorHandler.received(error);
        throw new Error(error.error?.message || 'Error al obtener los horarios de notificación');
      })
    );
  }

  actualizarHorarioNotificacion(body: { tipo_notificacion: string; hora: number; minuto: number }) {
    const url = `${this._baseUrl}/horarios-notificacion`;
    return this._httpClient.put(url, body).pipe(
      map((response: any) => response.payload),
      catchError((error: any) => {
        this._errorHandler.received(error);
        throw new Error(error.error?.message || 'Error al actualizar el horario de notificación');
      })
    );
  }
}
